export default __webpack_public_path__ + "static/media/ReminderWeb.fa627204.png";